import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Dropdown, Icon, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import TourNav from "../../constants/TourNav";
import "../../styles/TourMobileMenu.less";
import TourAcl from "~/models/Tour/TourAcl";
import User from "~/models/User";
import AuthenticatedUserHelper from "~/utils/AuthenticatedUserHelper";

const TourMobileMenu = observer(({ tourId, active, tourAcl, user, token, t }) => (
  <Dropdown text="Menu" floating button icon="dropdown" className="tour-mobile-menu-wrap">
    <Dropdown.Menu position="right">
      {tourAcl.download && (
        <Dropdown.Item
          as={Link}
          to={
            AuthenticatedUserHelper.isAuthenticated(user)
              ? `/tours/${tourId}/download`
              : `/tours/${tourId}/download?token=${token}`
          }
          active={active === TourNav.DOWNLOAD}
        >
          <Icon name="cloud download" />
          {t("clientPanelMisc:downloadCenter")}
        </Dropdown.Item>
      )}
      {/* Access only if authenticated as Customer */}
      {AuthenticatedUserHelper.isAuthenticatedCustomer(user) && (
        <>
          {tourAcl.info && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/info`} active={active === TourNav.INFO}>
              <Icon name="info circle" />
              {t("clientPanelMisc:info")}
            </Dropdown.Item>
          )}
          {tourAcl.address && (
            <Dropdown.Item
              as={Link}
              to={`/tours/${tourId}/address`}
              active={active === TourNav.ADDRESS || active === ""}
            >
              <Icon name="map marker alternate" />
              {t("clientPanelMisc:address")}
            </Dropdown.Item>
          )}
          {tourAcl.mls && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/mls`} active={active === TourNav.MLS}>
              <Icon name="cog" />
              {t("clientPanelMisc:mls")}
            </Dropdown.Item>
          )}
          {tourAcl.settings && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/settings`} active={active === TourNav.SETTINGS}>
              <Icon name="wrench" />
              {t("clientPanelMisc:settings")}
            </Dropdown.Item>
          )}
          {tourAcl.immersive3dTour && (
            <Dropdown.Item
              as={Link}
              to={`/tours/${tourId}/immersive-3d-tour`}
              active={active === TourNav.IMMERSIVE_3D_TOUR}
            >
              <Image className="icon customIcon" src="/assets/images/trivaxis_sigil.svg" />
              {t("immersive3dTour")}
            </Dropdown.Item>
          )}
          {tourAcl.uiMeet3d && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/ui-meet-3d`} active={active === TourNav.UI_MEET_3D}>
              <Image className="icon customIcon" src="/assets/images/trivaxis_sigil.svg" />
              {t("uiMeet3d")}
            </Dropdown.Item>
          )}
          {tourAcl.mediaEdit && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/media-edit`} active={active === TourNav.MEDIA_EDIT}>
              <Icon name="image" />
              {t("clientPanelMisc:mediaEdit")}
            </Dropdown.Item>
          )}
          {tourAcl.mediaSettings && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/media-settings`} active={active === TourNav.MEDIA_SETTINGS}>
              <Icon name="sliders" />
              {t("clientPanelMisc:mediaSettings")}
            </Dropdown.Item>
          )}
          {tourAcl.videoRequest && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/video-request`} active={active === TourNav.VIDEO}>
              <Icon name="video" />
              {t("clientPanelMisc:videoRequest")}
            </Dropdown.Item>
          )}
          {tourAcl.flyer && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/flyer`} active={active === TourNav.FLYER}>
              <Icon name="file alternate" />
              {t("clientPanelMisc:flyerEdit")}
            </Dropdown.Item>
          )}
          {tourAcl.stats && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/stats`} active={active === TourNav.STATS}>
              <Icon name="chart bar" />
              {t("clientPanelMisc:stats")}
            </Dropdown.Item>
          )}
          {tourAcl.links && (
            <Dropdown.Item as={Link} to={`/tours/${tourId}/links`} active={active === TourNav.LINKS}>
              <Icon name="linkify" />
              {t("clientPanelMisc:links")}
            </Dropdown.Item>
          )}
        </>
      )}
    </Dropdown.Menu>
  </Dropdown>
));

TourMobileMenu.propTypes = {
  tourId: PropTypes.number.isRequired,
  active: PropTypes.string,
  tourAcl: PropTypes.instanceOf(TourAcl).isRequired,
  user: PropTypes.instanceOf(User),
  token: PropTypes.string,
  t: PropTypes.func.isRequired,
};

TourMobileMenu.defaultProps = {
  active: "",
  token: null,
};

export default withTranslation()(TourMobileMenu);
